import React from 'react';
import { Switch, Route } from 'react-router';

import ProjectCreate from './ProjectCreate';
import ProjectEdit from './ProjectEdit';
import RouteGetter from '../../../routes/RouteGetter';

const Overview = () => {
  return (
    <Switch>
      <Route path={RouteGetter.get('project').newPage()}>
        <ProjectCreate />
      </Route>
      <Route exact path={RouteGetter.get('project').overviewPath()}>
        <ProjectEdit />
      </Route>
    </Switch>
  );
};

export default Overview;
